import React from 'react';
import './MediaUpload.scss';
import AnimatedEllipsis from '../AnimatedEllipses/AnimatedEllipses';
import { ADMIN_ROLE } from '../../constants/global';


const ScanningView = ({fileName, fileSize, org_role}) => {
  return <>
    {org_role!==ADMIN_ROLE?(
      <div className='uploadrow'>
      <div className='scanrow uploadcard'>
        <span className ="cb-icon cb-upload  cb-icon-14" style={{marginRight:'10px'}}></span>

        <div style={{display:'flex', flexDirection:'column', width:'60%'}}>
          <span className='uploadfileFont'> {fileName}</span>
          <span>{fileSize}</span>
        </div>
        <AnimatedEllipsis />
      </div></div>)
    :
    (
      <div className='uploadrowadmin' style={{alignItems: 'baseline', display: 'flex'}}>
        <div className='scanrow uploadcard'>
          <span className ="cb-icon cb-upload  cb-icon-14" style={{marginRight:'10px'}}></span>
          <div style={{display:'flex', flexDirection:'column', width:'60%'}}>
            <span className='uploadfileFont'> {fileName}</span>
            <span>{fileSize}</span>
          </div>
          <AnimatedEllipsis />
        </div>
        <button type='button' className={`cb-btn cb-btn-primary`} disabled style={{marginLeft:'20px'}}>Reject</button>
        <button type='button' className={`cb-btn cb-btn-primary`} disabled style={{marginLeft:'10px'}}>Accept</button>
      </div>
    )}
    </>;
};



export default ScanningView;